import { Link } from "react-router-dom";

import { ApplicationContextualHelp } from "../../components/application";

const MODE_DESCRIPTIONS = {
  "random-practice":
    "All-Voiced selects a voice sample for you at random.",
  "select-practice":
    "Choose a voice sample from those available in All-Voiced.",
  "upload-sample":
    "Use one of your own voice recordings.",
};

export function getCapeVrEquivalentSlugForRecommendation(
  entry,
  adaptationId
) {
  const slug = entry?.slug;

  if (typeof slug !== "string" || adaptationId !== "en") {
    return null;
  }

  if (slug === "capev") {
    return "capevr";
  }

  if (slug.startsWith("capev-")) {
    return slug.replace(/^capev-/, "capevr-");
  }

  return null;
}

export function CAPEVActivityModeHelp({
  availableLaunchConfigurations = [],
}) {
  const visibleModes = availableLaunchConfigurations.filter(
    (configuration) =>
      MODE_DESCRIPTIONS[configuration?.id]
  );

  return (
    <ApplicationContextualHelp
      label="About activity modes"
      title="About activity modes"
    >
      <p>
        Activity modes let you choose how you want to use this
        activity.
      </p>
      <ul className="av-app-contextual-help__list">
        {visibleModes.map((configuration) => (
          <li key={configuration.id}>
            <strong>{configuration.label}</strong>
            {" — "}
            {MODE_DESCRIPTIONS[configuration.id]}
          </li>
        ))}
      </ul>
      <p>
        You can set a mode as your default so All-Voiced opens
        this activity in that mode next time.
      </p>
    </ApplicationContextualHelp>
  );
}

export function CAPEVAdaptationHelp({
  capeVrCatalogTo = null,
}) {
  return (
    <ApplicationContextualHelp
      label="About CAPE-V adaptations"
      title="About CAPE-V adaptations"
    >
      <p>
        Choose the CAPE-V language adaptation you want to use.
        The selector shows the adaptations currently available in
        All-Voiced.
      </p>
      <p>
        Planning a new evaluation in English? We recommend using{" "}
        {capeVrCatalogTo ? (
          <Link to={capeVrCatalogTo}>CAPE-Vr</Link>
        ) : (
          "CAPE-Vr"
        )}
        {", "}
        the revised version of CAPE-V.
      </p>
    </ApplicationContextualHelp>
  );
}
